import { Temporal } from 'temporal-polyfill';

export class WrappedPlainTimeInterval {
  constructor(
    private readonly start: Temporal.PlainTime,
    private readonly end: Temporal.PlainTime,
  ) {
    if (Temporal.PlainTime.compare(start, end) > 0) {
      throw new Error('Start time must be before or equal to end time');
    }
  }

  *step(step: Temporal.Duration): IterableIterator<Temporal.PlainTime> {
    if (step.sign <= 0) {
      throw new Error('Step must be a positive duration');
    }

    for (let current = this.start; Temporal.PlainTime.compare(current, this.end) <= 0; current = current.add(step)) {
      yield current;

      const stepSeconds = step.total({ unit: 'seconds' });
      const currentTotalSeconds = current.hour * 3600 + current.minute * 60 + current.second;
      const nextTotalSeconds = currentTotalSeconds + stepSeconds;

      //Check if next total seconds exceeds 24 hours
      if (nextTotalSeconds >= 24 * 60 * 60) {
        break;
      }
    }
  }
}
